/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/views/layout/Layout'

const componentsRouter = {
    path: '/map',
    component: Layout,
    name: 'Monitor',
    menuid: 212,
    systemtypeid: 0,
    meta: {
      title: 'MonitorTitle',
      icon: 'wechat'
    },
    children: [
      {
        path: 'set',
        component: () => import('@/views/map/index'),
        name: 'MonitorMap',
        menuid: 213,
        systemtypeid: 0,
        meta: {title: 'MonitorMap', icon: 'table'}
      },   
    ]
  }

export default componentsRouter



// WEBPACK FOOTER //
// ./src/router/modules/monitor.js